import { type SelectedProduct } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function findSelectedProduct(params: Params) {
  const { selectedProducts, selectionId } = params;

  return selectedProducts.find((selectedProduct) => selectedProduct.selectionId === selectionId);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  selectedProducts: SelectedProduct[];
  selectionId: string;
};
